<template>
  <div class="map">
    <app-loader v-if="!mapReady" />
    <yandex-map :coords="coords" :controls="['zoomControl']" zoom="16" style="width: 100%; height: 100%;">
      <ymap-marker marker-type="placemark" :coords="marker" hint-content='СТО АВТОДИЗЕЛЬ' :balloon="{header: 'СТО АВТОДИЗЕЛЬ', body: 'Ленинградская 1 <br> 099 070 50 42 <br> +7 856  387 44 61 ', footer: 'Время работы с 9:00 - 17:00 по записи'}" :icon="{color: 'red', glyph: 'theater'}">
      </ymap-marker>
    </yandex-map>
  </div>

</template>

<script>
  import AppLoader from './AppLoader'
  import { yandexMap, ymapMarker } from 'vue-yandex-maps'
  export default {
    components: { yandexMap, ymapMarker, AppLoader },
    data () {
      return {
        mapReady: false,
        coords: [48.000187, 37.7665745],
        marker: [48.000587, 37.7665745]
      }
    },
    methods: {
      showMap () {
        this.mapReady = true
      }
    },
    created () {
      setTimeout(this.showMap, 2000)
    }
  }
</script>
<style lang="stylus" scoped>
  .map
    width 100%
    height 100%
</style>



// WEBPACK FOOTER //
// Maps.vue?2150292e